var katex = { exports: {} };
export {
  katex as __module
};
//# sourceMappingURL=katex.js.map
